import { AnimatePresence, motion } from "framer-motion";

const AnimateProviderState = ({ states }) => {
  return (
    <AnimatePresence mode="wait">
      {states.map((state) => {
        return state.shouldRender ? (
          <motion.div
            key={state.key}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {state.child}
          </motion.div>
        ) : null;
      })}
    </AnimatePresence>
  );
};

export default AnimateProviderState;
